import { isNil } from 'lodash';

const share = async (data: ShareData): Promise<boolean> => {
  if (canShare() && navigator.canShare(data)) {
    try {
      await navigator.share(data);
    } catch (e) {
      console.log('share error', e);

      throw e;
    }

    return true;
  } else {
    throw new Error('Функция "Поделиться" не поддерживается');
  }
};

export const canShare = (): boolean =>
  !isNil(navigator.share) && !isNil(navigator.canShare);

export default share;
